import React, { ComponentProps } from 'react';
import { FieldWrapper } from '../FieldWrapper';
import { ImageInput } from '../FormItems';

type FieldWrapperProps = ComponentProps<typeof FieldWrapper>;

type Props = {
  imageInput?: ComponentProps<typeof ImageInput>;
  fieldWrapperProps: Omit<FieldWrapperProps, 'children'>;
};

export const ImageInputField: React.FC<Props> = ({
  imageInput,
  fieldWrapperProps: { htmlFor, labelType, labelText, beforeMessage, errorMessages },
  ...rest
}) => (
  <FieldWrapper
    htmlFor={htmlFor}
    labelType={labelType}
    labelText={labelText}
    beforeMessage={beforeMessage}
    errorMessages={errorMessages}
  >
    <ImageInput id={htmlFor} {...imageInput} {...rest} />
  </FieldWrapper>
);
